(() => {
  function setupStickyCart() {
    const bar = document.querySelector('[data-wm-sticky-cart]');
    const mainButton = document.querySelector('#MainContent .product-form__submit');
    if (!bar || !mainButton) return;
    const stickyButton = bar.querySelector('[data-wm-sticky-button]');
    const price = bar.querySelector('[data-wm-sticky-price]');
    const variant = bar.querySelector('[data-wm-sticky-variant]');
    const productPrice = document.querySelector('#MainContent .product__info-container .price');
    const setBarVisibility = (visible) => {
      bar.hidden = !visible;
      document.documentElement.classList.toggle('wm-sticky-cart-visible', visible);
    };
    // Always-on sticky add to cart (Shrine-style): stays visible at every scroll position.
    setBarVisibility(true);
    stickyButton.addEventListener('click', () => {
      if (!mainButton.disabled) mainButton.click();
      else mainButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    const sync = () => {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.textContent.trim() || 'Add to cart';
      if (productPrice && price) {
        const currentPrice = productPrice.querySelector('.price__sale .price-item--last')
          || productPrice.querySelector('.price__regular .price-item--regular')
          || productPrice.querySelector('.price-item--regular');
        if (currentPrice) price.textContent = currentPrice.textContent.trim();
      }
      if (variant) {
        const selectedOptions = [...document.querySelectorAll('#MainContent .product-form__input input[type="radio"]:checked')]
          .map((input) => input.value)
          .filter(Boolean);
        const selects = [...document.querySelectorAll('#MainContent .product-form__input select')]
          .map((select) => select.options[select.selectedIndex]?.text)
          .filter(Boolean);
        const optionText = [...selectedOptions, ...selects].join(' / ');
        if (optionText) variant.textContent = optionText;
      }
    };
    new MutationObserver(sync).observe(mainButton, { attributes: true, childList: true, subtree: true });
    if (productPrice) new MutationObserver(sync).observe(productPrice, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', (event) => {
      if (event.target.closest('#MainContent .product-form__input')) window.setTimeout(sync, 0);
    });
    window.addEventListener('pagehide', () => document.documentElement.classList.remove('wm-sticky-cart-visible'), { once: true });
    sync();
  }

  function setupCalculators() {
    for (const root of document.querySelectorAll('[data-wm-calculator]')) {
      const output = root.querySelector('[data-wm-calculator-result]');
      const note = root.querySelector('[data-wm-calculator-note]');
      const calculate = () => {
        const number = (name) => Number(root.querySelector(`[name="${name}"]`).value);
        const wall = number('wall');
        const frames = number('frames');
        const margin = number('margin');
        const gap = number('gap');
        const available = wall - margin * 2 - gap * (frames - 1);
        if (!Number.isFinite(available) || wall <= 0 || frames < 1 || !Number.isInteger(frames) || margin < 0 || gap < 0 || available <= 0) {
          output.textContent = 'Check your measurements';
          note.textContent = 'The wall must be wider than the combined margins and gaps.';
          return;
        }
        output.textContent = `${(available / frames).toFixed(1)} in`;
        note.textContent = 'Measure the actual wall before ordering.';
      };
      root.addEventListener('input', calculate);
      calculate();
    }
    for (const root of document.querySelectorAll('[data-wm-batten-calculator]')) {
      const output = root.querySelector('[data-wm-batten-result]');
      const note = root.querySelector('[data-wm-batten-note]');
      const calculate = () => {
        const number = (name) => Number(root.querySelector(`[name="${name}"]`).value);
        const wall = number('wall');
        const battens = number('battens');
        const margin = number('margin');
        const battenWidth = number('batten_width');
        const available = wall - margin * 2 - battens * battenWidth;
        if (!Number.isFinite(available) || wall <= 0 || battens < 2 || !Number.isInteger(battens) || margin < 0 || battenWidth <= 0 || available <= 0) {
          output.textContent = 'Check your measurements';
          note.textContent = 'The wall must be wider than the battens and side margins combined.';
          return;
        }
        output.textContent = `${(available / (battens - 1)).toFixed(1)} in`;
        note.textContent = 'Check actual material dimensions before ordering.';
      };
      root.addEventListener('input', calculate);
      calculate();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { setupStickyCart(); setupCalculators(); });
  else { setupStickyCart(); setupCalculators(); }
})();

// Wall designer (mobile): after choosing a start option, bring the whole designer into view.
document.addEventListener('click', (event) => {
  if (!window.matchMedia('(max-width: 900px)').matches) return;
  const button = event.target.closest('.twh-wc button');
  if (!button || !/^(Blank wall|Example room|Continue my last design)/.test(button.innerText.trim())) return;
  window.setTimeout(() => document.querySelector('.twh-wc')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 200);
});
